import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'phone',
  standalone: false
})
export class PhonePipe implements PipeTransform {
  public transform(value: any): any {
    if (!value) {
      return ''
    }

    value = value.replaceAll(/\D/g, '')

    if (value.length === 10) {
      return value.replace(/(?<areaCode>\d{2})(?<prefix>\d{4})(?<lineNumber>\d{4})/, '($<areaCode>) $<prefix>-$<lineNumber>')
    }

    if (value.length === 11) {
      return value.replace(/(?<areaCode>\d{2})(?<prefix>\d{5})(?<lineNumber>\d{4})/, '($<areaCode>) $<prefix>-$<lineNumber>')
    }

    return value
  }
}
